import React, { Component } from 'react'
import NoughtsCrosses from './containers/NoughtsCrosses'

class App extends Component {
  render() {
    return <NoughtsCrosses />
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js